import React, { useEffect, useState, useRef } from "react";
import logo from "../../assets/WHL-LOGO.png";
import biz from "../../assets/bizsafe.jpg";
import iso from "../../assets/iso.jpg";
import { useReactToPrint } from "react-to-print";
import axiosInstance from "../../services/auth";

import "./Invoice.css";
import { useCombinedContext } from "../../context/CombinedContext";
import { toWords } from "number-to-words";

const InvoiceView = ({ userRole, invoice, isViewMode, setIsViewMode }) => {
  const [isPrinting, setIsPrinting] = useState(false);
  const [isMultiplePages, setIsMultiplePages] = useState(false);

  const { selectesVessel, selectedCompany } = useCombinedContext();
  const company = selectedCompany;

  const items = invoice.bill;
  // console.log("Invoice for print",invoice)
  useEffect(() => {
    const adjustInvoiceHeight = () => {
      const invoiceSection = document.getElementById("main_invoice");
      const pageHeight = 701; // Page height for reference
      // console.log(pageHeight);
      // const minHeight = 400;
      if (invoiceSection) {
        const contentHeight = invoiceSection.offsetHeight;
        // console.log(contentHeight);

        // If content height is greater than page height, set to dynamic height
        if (contentHeight > pageHeight) {
          invoiceSection.style.minHeight = "1727px";
        } else {
          invoiceSection.style.minHeight = "700px";
        }
      }
    };

    adjustInvoiceHeight();

    // Add a resize listener to handle dynamic adjustments
    window.addEventListener("resize", adjustInvoiceHeight);

    return () => {
      window.removeEventListener("resize", adjustInvoiceHeight);
    };
  }, []);

  const printRef = useRef(null);
  const checkForMultiplePages = () => {
    const contentHeight = printRef.current.scrollHeight;
    const pageHeight = 1080; // Set the print page height limit (adjust as needed)
    setIsMultiplePages(contentHeight > pageHeight);
  };

  useEffect(() => {
    checkForMultiplePages();
  }, [printRef.current]);

  const invoicePrinted = async () => {
    try {
      // Pass the payload with { status: false } to the PATCH endpoint
      const response = await axiosInstance.patch(
        `/invoice/print/${invoice._id}`,
        {
          status: false,
        },
      );
      // console.log(response.data.message); // "Invoice Printed"
    } catch (error) {
      console.error("Error updating invoice status:", error);
    }
  };

  const handlePrint = useReactToPrint({
    content: () => printRef.current, // Pass the reference to the content
    pageStyle: `
    /* ${
      isMultiplePages
        ? `
      @page:first {
        border-bottom: 1px solid black;
        // padding-top:27px;
      }
      @page:last {
        border-bottom: none;
      }
    `
        : `
      @page:first {
        border-bottom: none;
      }
    `
    } */
    @page {
      @bottom-right {
            content: "Page " counter(page) " of " counter(pages);
          }
            
}`,
    onBeforePrint: () => {
      checkForMultiplePages();
      setIsViewMode(false);
    },
    onAfterPrint: () => {
      // After printing, call the API to update the status
      invoicePrinted();
    },
    // onBeforePrint: () => setIsViewMode(false),
  });
  function convertCurrencyToWords(number) {
    // Split the number into integer and decimal parts
    const [integerPart, decimalPart = "00"] = number.toString().split(".");

    // Convert the integer part (dollars) to words and remove hyphens
    let words = toWords(integerPart).replace(/-/g, " ");

    // Ensure the decimal part has two digits and convert it to words
    const paddedDecimal = decimalPart.padEnd(2, "0");
    let cents = toWords(paddedDecimal).replace(/-/g, " ");

    // Format the result as currency
    if (cents) {
      words += ` & Cents ${
        cents.charAt(0).toUpperCase() + cents.slice(1)
      } Only`;
    } else {
      words += " Only";
    }

    // Add "Dollars" before the amount
    words = words.charAt(0).toUpperCase() + words.slice(1); // Capitalize the first letter
    words = `Singapore Dollars: ${words}`;

    return words;
  }

  function formatPrice(price) {
    const num = parseFloat(price);
    if (isNaN(num)) return "N/A";
    return num.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }

  return (
    isViewMode && (
      <div
        className={`modal fade ${isViewMode ? "show d-block" : ""}`}
        style={{
          display: "block",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
        }}
        tabIndex="-1"
        role="dialog"
        aria-hidden={!isViewMode}
        onClick={(e) => {
          if (e.target.classList.contains("modal")) setIsViewMode(false);
        }}
      >
        <div
          className="modal-dialog modal-lg modal-dialog-centered invoice-container"
          style={{
            maxWidth: "850px",
            margin: "auto",
            display: "flex",
            alignContent: "center",
          }}
          role="document"
        >
          <div
            className="modal-content"
            style={{
              fontSize: "11px",
              backgroundColor: "#fff",
              // border: "none",
              borderRadius: "5px",
              boxShadow: "0px 10px 30px rgba(0, 0, 0, 0.1)",
              // padding: "10px",
            }}
          >
            {/* Modal Header */}
            <div
              className="modal-header d-print-none"
              style={{
                borderBottom: "none",
                //  paddingBottom: "px",
                textAlign: "center",
              }}
            >
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={() => setIsViewMode(false)}
              ></button>
            </div>
            <div ref={printRef} className="invoice" id="invoice">
              <div
                className="top_Heading"
                style={{ borders: "1px solid #000", borderBottom: "none" }}
              >
                <div
                  className="invoice_header"
                  style={{
                    paddingBottom: "px",
                    position: "relative",
                    borderBottom: "1px solid #000",
                    padding: "3px",
                  }}
                >
                  <div
                    className="header-row"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      // borderBottom: "1px solid #000",
                      paddingBottom: "",
                      marginBottom: "",
                    }}
                  >
                    <div style={{ flex: "0 0 auto" }}>
                      <img
                        src={logo}
                        alt="logo"
                        style={{
                          width: "125px",
                          height: "auto",
                          paddingRight: "20px",
                        }}
                      />
                    </div>
                    <div
                      style={{
                        textAlign: "left",
                        flex: "1",
                        paddingLeft: "5px",
                        paddingRight: "5px",
                      }}
                    >
                      <h2
                        className="company_font "
                        h2
                        style={{
                          margin: 0,
                          textDecoration: "underline",
                        }}
                      >
                        {company.company_name}
                      </h2>
                      <p style={{ margin: 0, fontSize: "12px" }}>
                        {`Co Reg No: ${company.co_regno} GST No: ${company.gst_no}`}
                        <br />
                        {company.address}
                        <br />
                        {`Tel: ${company.telephone} Fax: ${company.fax}`}

                        <br />
                        {company.email}
                      </p>
                    </div>
                  </div>
                  <div
                    className="invoice_logo"
                    style={{
                      position: "absolute",
                      top: "60px",
                      right: "-13px",
                    }}
                  >
                    <img
                      src={biz}
                      alt="biz safe"
                      style={{
                        width: "70px",
                        height: "auto",
                        paddingRight: "5px",
                      }}
                    />
                    <img
                      src={iso}
                      alt="iso"
                      style={{
                        width: "65px",
                        height: "auto",
                        paddingRight: "20px",
                      }}
                    />
                  </div>
                </div>
                <div style={{ textAlign: "center" }}>
                  <h5 className="text-uppercase text-decoration-underline mt-2">
                    Tax Invoice
                  </h5>
                </div>
                <div className="row" style={{ padding: "3px" }}>
                  <div className="col-md-6">
                    <p style={{ marginBottom: "5px" }}>
                      {invoice.supplier?.yard_name || "NA"}
                      <br />
                      {invoice.supplier?.address || "NA"}
                      <br />
                      {invoice.supplier?.country || "NA"}&nbsp;
                      {invoice.supplier?.pincode || "NA"}
                    </p>
                  </div>
                </div>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "3px",
                  }}
                >
                  <div>
                    <tr>
                      <td className="pe-4">Project Name</td>
                      <td>:&nbsp;{invoice?.project_code?.vessel_name}</td>
                      <br />
                    </tr>
                    <tr>
                      <td>Job No</td>
                      <td>:&nbsp;{invoice.job_no}</td>
                      <br />
                    </tr>
                    <tr>
                      <td>Trade</td>
                      <td>:&nbsp;{invoice.trade}</td>
                      <br />
                    </tr>
                    {["admin", "superadmin"].includes(userRole) && (
                      <tr>
                        <td>Bank Account</td>
                        <td>:&nbsp;{invoice.company.bank_account_no}</td>
                        <br />
                      </tr>
                    )}
                  </div>
                  <div>
                    <tr>
                      <td className="text-end">Invoice No&nbsp;</td>
                      <td>:&nbsp;{invoice.invoice_no}</td>
                    </tr>
                    <tr>
                      <td className="text-end">Work Order No&nbsp;</td>
                      <td>:&nbsp;{invoice.order_no}</td>
                    </tr>
                    <tr>
                      <td className="text-end">Date&nbsp;</td>
                      <td>
                        :&nbsp;
                        {invoice.invoice_date
                          ? new Date(invoice.invoice_date).toLocaleDateString()
                          : null}
                      </td>
                    </tr>{" "}
                  </div>
                </div>
              </div>
              <table id="main_invoice" className="main_invoice">
                <thead>
                  <tr className="table_Title">
                    <th
                      className="table_column_1 text-center"
                      style={{ minWidth: "5%" }}
                    >
                      S/NO
                    </th>
                    <th
                      className="table_column_2 text-center"
                      style={{ minWidth: "8%" }}
                    >
                      JOB NO
                    </th>
                    <th className="table_column_3" style={{ width: "auto" }}>
                      Description
                    </th>
                    <th
                      className="table_column_4 text-center"
                      style={{ minWidth: "10%" }}
                    >
                      Qty
                    </th>
                    <th
                      className="table_column_5 text-center"
                      style={{ minWidth: "10%" }}
                    >
                      Unit Price
                    </th>
                    <th
                      className="table_column_6 text-center"
                      style={{ minWidth: "13%" }}
                    >
                      Amount
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {items.map((item, index) => (
                    <tr
                      className="bill_items"
                      style={{
                        borderTop: "none",
                        borderBottom: "none",
                      }}
                      key={index}
                    >
                      <td className="text-center">{index + 1}</td>
                      <td
                        className="table_column_2 text-center "
                        style={{ minWidth: "15%" }}
                      >
                        {item.job_no}
                      </td>
                      <td className="table_column_3">{item.description}</td>
                      <td className="text-center ">
                        {formatPrice(item.quantity.toFixed(2))}
                      </td>

                      <td className="right-align ">
                        <div className="d-flex justify-content-between">
                          <span>$ </span>{" "}
                          <span>{formatPrice(item.unit_price.toFixed(2))}</span>
                        </div>
                      </td>
                      <td className="right-align ">
                        <div className="d-flex justify-content-between">
                          <span>$ </span>{" "}
                          <span>{formatPrice(item.amount.toFixed(2))}</span>
                        </div>
                      </td>
                    </tr>
                  ))}
                  <tr className="spacer-row">
                    <td className="spacer-cell"></td>
                    <td className="spacer-cell"></td>
                    <td className="spacer-cell"></td>
                    <td className="spacer-cell"></td>
                    <td className="spacer-cell"></td>
                    <td className="spacer-cell"></td>
                  </tr>
                  <tr className="break1 total">
                    <td
                      colSpan="3"
                      rowSpan={
                        ["admin", "superadmin"].includes(userRole) ? "3" : "1"
                      }
                    >
                      {" "}
                      {["admin", "superadmin"].includes(userRole) && (
                        <div className="d-flex align-content-end align-items-end">
                          {convertCurrencyToWords(invoice.total_with_gst)}
                        </div>
                      )}
                    </td>
                    <td colSpan="2" className="text-end ">
                      Sub Total
                    </td>
                    <td>
                      <div className="d-flex justify-content-between">
                        <span>$ </span>{" "}
                        <span>
                          {" "}
                          {formatPrice(invoice.total_without_gst.toFixed(2))}
                        </span>
                      </div>
                    </td>
                  </tr>
                  {["admin", "superadmin"].includes(userRole) && (
                    <>
                      <tr className="total">
                        <td colSpan="2" className="text-end">
                          {`Add ${invoice.gst_rate}% GST`}
                        </td>
                        <td>
                          <div className="d-flex justify-content-between">
                            <span>$ </span>{" "}
                            <span>
                              {" "}
                              {formatPrice(invoice.gst_amount.toFixed(2))}
                            </span>
                          </div>
                        </td>
                      </tr>
                      <tr className="total">
                        <td colSpan="2" className="text-end">
                          Total Amount With GST
                        </td>

                        <td>
                          <div className="d-flex justify-content-between">
                            <span>$ </span>{" "}
                            <span>
                              {" "}
                              {formatPrice(invoice.total_with_gst.toFixed(2))}
                            </span>
                          </div>
                        </td>
                      </tr>
                    </>
                  )}
                  <tr>
                    <td colSpan="6">
                      <div /* style={{
            position: "absolute",
            bottom: "15mm",
            left: 0,
            right: 0,
            textAlign: "start",
            fontSize: "10px",
          }} */
                      >
                        <div className="col-md-6">
                          <div
                            style={{
                              marginBottom: "60px",
                              marginTop: "7px",
                            }}
                          >
                            <strong className="d-block">Approved by,</strong>
                          </div>
                          <div>
                            <p
                              style={{
                                marginBottom: "0",
                              }}
                            >
                              <strong>_________________________</strong>
                              <br />
                              <strong className="">Name:</strong> Naveen Paul
                              <br />
                              <strong className="">Designation:</strong>{" "}
                              Director
                            </p>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                  {/* Add invoice rows dynamically */}
                </tbody>
                <tfoot></tfoot>
              </table>
            </div>
            <div className="d-flex justify-content-center">
              {["admin", "superadmin"].includes(userRole) && (
                <button
                  className="button-2  text-end mb-5"
                  onClick={handlePrint}
                >
                  Print Invoice
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    )
  );
};

export default InvoiceView;
